import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ReplaySubject, Subscription} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {AppService} from '@irb/app.service';
import {PageService} from '@irb-common/services/page.service';
import {IrbDashboardService} from '@irb/irb-dashboard/irb-dashboard.service';
import {IGlobalSettings, IRebalanceDetails} from '@irb/irb-dashboard/irb-dashboard.model';
import {IApplyFilterOnLanding} from '@irb/app.model';
import {IrbRebalanceEvents} from '@irb/irb-common/events';
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';

@Component({
  standalone: false,
  selector: 'irb-module-rebalancing',
  templateUrl: './module-rebalancing.component.html',
  styleUrls: ['./module-rebalancing.component.scss']
})
export class ModuleRebalancingComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  private _data: Array<IRebalanceDetails>;
  private masterAccountSubscription: Subscription;
  selectedMasterAccounts: Array<string> = [];
  initailLoadPassed = false;
  @Input() singleWidth: boolean;
  @Input() customizableMode: boolean = false;
  @Input() globalSettings: IGlobalSettings;

  constructor(
    public as: AppService,
    public ps: PageService, 
    private dbs: IrbDashboardService, 
    private router: Router,
    private ats: AnalyticsService
  ) {}

  ngOnInit() {
    if (this.customizableMode)
      return;

    this.ps.getUserDetails().pipe(takeUntil(this.destroyed$)).subscribe((d) => {   
      if(d) {
        this.ps.deserializePageState(this.as.getFromSession("pageState"),["rebalResultsGridDiv"]);

        this.masterAccountSubscription = this.dbs.currentMasterAccountData.subscribe(passedSelectedMasterAccounts => {
          if (this.initailLoadPassed) {
            this.data = null;
            this.selectedMasterAccounts = passedSelectedMasterAccounts;
            if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
              this.getRebalanceDetailsForSelectedAccounts();
            else
              this.getRebalanceDetailsForAllAccounts();
          }
        });

        this.initailLoadPassed = true;
        this.selectedMasterAccounts = this.dbs.selectedMasterAccounts;
        if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
          this.getRebalanceDetailsForSelectedAccounts();
        else
          this.getRebalanceDetailsForAllAccounts();
      }
    });
  }

  getRebalanceDetailsForAllAccounts() {
    this.dbs.getRebalanceDetails().pipe(takeUntil(this.destroyed$)).subscribe((d) => {
      this.data = (d as Array<IRebalanceDetails>).slice(0,9);
    });
  }

  getRebalanceDetailsForSelectedAccounts() {
    this.dbs.getRebalanceDetailsForMasters(this.selectedMasterAccounts).pipe(takeUntil(this.destroyed$)).subscribe({
      next: (d: any) => {
        this.data = (d as Array<IRebalanceDetails>).slice(0,9);
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  showCreateRebalance() {
    const crConfig = { 
      fullscreen: true
    };
    
    this.ats.trackClickEvent("md_createrebal");
    this.as.fireEvent(IrbRebalanceEvents.SHOW_EDIT_CREATE_REBALANCE, crConfig);
  }

  showRebalanceResultSummary(rebalPkgId: number) {
  
    const state: IApplyFilterOnLanding = {
      isUpdatRequired: true,
      filterModel: { name: 'rebalPkgId', value:[rebalPkgId+""] , isUpdatRequired: true }
    } as IApplyFilterOnLanding;

    this.router.navigate(["/rebalancing/result-summary/", rebalPkgId]);
  }

  get data(): Array<IRebalanceDetails> {
    return this._data;
  }

  set data(d: Array<IRebalanceDetails>) {
    this._data = d;
  }
}
